import { render, staticRenderFns } from "./PccOrderCostOfServicesEdit.vue?vue&type=template&id=5527eff0&scoped=true&"
import script from "./PccOrderCostOfServicesEdit.vue?vue&type=script&lang=js&"
export * from "./PccOrderCostOfServicesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5527eff0",
  null
  
)

export default component.exports